import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

export const tooltipContentVariants = cva(
  cn(
    // max-w 400px is the design-wide cap for tooltip line length (Deborah, DEV-6279 review).
    // py-1.5 (not py-1): at 14px/20px the last line's descenders sit ~2px off the
    // content edge, so wrapped tooltips clipped the tails of g/y on some setups.
    'isolate z-[9999] min-h-6 max-w-[400px] select-none rounded px-2 py-1.5 text-sm will-change-[transform,opacity] data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade',
    'border border-solid',
    'shadow-[0_1px_4px_0_rgba(21,26,32,0.04)]'
  ),
  {
    variants: {
      variant: {
        default:
          'border-gray-150 bg-gray-50 text-gray-950 dark:border-gray-800 dark:bg-gray-900 dark:text-white',
        inverted: 'bg-gray-900 text-white dark:bg-white dark:text-gray-950',
        card: 'border-gray-150 bg-white text-gray-950 dark:border-gray-800 dark:bg-gray-875 dark:text-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

/**
 * Allows the arrow to have a partial border which extends the outline of the tooltip
 * by blending the top borders of the custom arrow with the background of the tooltip content
 */
export const tooltipCustomArrowVariants = cva(
  'translate-y-[-50%] border border-solid bg-current',
  {
    variants: {
      variant: {
        default:
          'border-gray-150 border-t-gray-50 border-l-gray-50 bg-gray-50 dark:border-gray-800 dark:border-t-gray-900 dark:border-l-gray-900 dark:bg-gray-900',
        inverted:
          'border-gray-900 text-gray-900 dark:border-gray-150 dark:text-white',
        card: 'border-gray-150 border-t-white border-l-white bg-white dark:border-gray-800 dark:border-t-gray-875 dark:border-l-gray-875 dark:bg-gray-875',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export const tooltipArrowSizeVariants = cva('', {
  variants: {
    size: {
      sm: 'h-1.5 w-3',
      default: 'h-2 w-4',
      lg: 'h-3 w-6',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const tooltipCustomArrowSizeVariants = cva('', {
  variants: {
    size: {
      sm: 'h-2 w-2',
      default: 'h-3 w-3',
      lg: 'h-4 w-4',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
